<div id="safety-duo-route-assignment-list"></div>